import { createClient } from '@/shared/api';
import type { CancelStudyMutation, CancelStudyMutationVariables } from '@/shared/api';
import CANCEL_STUDY_MUTATION from '../mutations/cancelStudy';

/**
 * Cancels a study before it has started. Runs CANCEL_STUDY_MUTATION and throws the returned message when isSuccess is false.
 *
 * @param id - Identifier of the study to cancel.
 * @returns A promise resolving once the mutation result has been checked for success.
 */
const handleCancelStudy = async (id: any) => {
  const client = createClient();
  const cancelStudyResult = await client.mutate<CancelStudyMutation, CancelStudyMutationVariables>({
    mutation: CANCEL_STUDY_MUTATION,
    variables: { id },
  });
  if (!cancelStudyResult?.data?.cancelStudy?.isSuccess) {
    throw new Error(cancelStudyResult?.data?.cancelStudy?.message ?? undefined);
  }
};

export default handleCancelStudy;
